import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	max: number;
	onConfirm: () => void;
	onReject: () => void;
}

interface BlockSettingsVisualizationSwitchConfirmComponentInterface {
	Element: HTMLDivElement;
	Args: Args;
}

export default class BlockSettingsVisualizationSwitchConfirmComponent extends Component<BlockSettingsVisualizationSwitchConfirmComponentInterface> {
	get warningText() {
		const max = this.args.max;
		if (max === 1) {
			return 'By switching to a visualization type that can host only a single metric, you will keep the first metric and remove all others.';
		} else {
			return `By switching to a visualization type that can host only ${max} metrics, you will keep the first ${max} metrics and remove all others.`;
		}
	}

	<template>
		<div class="bs__visualizations__confirm">
			<CommonUiIconComponent @name="AlertFill" @size="sm" />
			<p>{{this.warningText}}</p>
			<a class="button size-small" {{on "click" @onConfirm}}>OK, switch</a>
			<a class="cancel" {{on "click" @onReject}}>Cancel</a>
		</div>
	</template>
}
